function isTruthyFlag(value) {
  return value === 1 || value === true || value === "1";
}

export function isEtsyShopNameVisible(shop) {
  if (!shop) return true;
  if (shop.is_visible != null) return isTruthyFlag(shop.is_visible);
  if (shop.visibility != null) {
    if (typeof shop.visibility === "string") {
      const value = shop.visibility.toLowerCase();
      if (value === "hidden" || value === "false" || value === "0") return false;
      return true;
    }
    return isTruthyFlag(shop.visibility);
  }
  if (shop.is_hidden != null) return !isTruthyFlag(shop.is_hidden);
  if (shop.hide_shop_name != null) return !isTruthyFlag(shop.hide_shop_name);
  return true;
}

export function normalizeEtsyShop(shop) {
  if (!shop || typeof shop !== "object") return shop;
  return {
    ...shop,
    is_visible: isEtsyShopNameVisible(shop) ? 1 : 0,
  };
}
